import { Router, Routes, UrlTree } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LandingComponent } from './landing/landing.component';
import { EnergyUsageDashboardComponent } from './energy-usage-dashboard/energy-usage-dashboard.component';
import { OptimiseComponent } from './optimise/optimise.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { CtmDashboardComponent } from './ctm-dashboard/ctm-dashboard.component';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { inject } from '@angular/core';
import { catchError, concatMap, Observable, of } from 'rxjs';
import { PermissionGuard } from './guards/permission.guard';
import { DefaultRouteGuard } from './guards/default-route.guard';

export const CustomMsalGuard = (): Observable<boolean | UrlTree> => {
  const msalService = inject(MsalService);
  const msalBroadcastService = inject(MsalBroadcastService);
  const router = inject(Router);

  // Log that the guard was invoked (you can adjust logging as needed)
  msalService.getLogger().verbose('Custom functional guard invoked');

  // Initialize the authentication service, handle redirects, etc.
  return msalService.initialize().pipe(
    concatMap(() => msalService.handleRedirectObservable()),
    concatMap(() => {
      // If there are no authenticated accounts, return false without triggering login
      if (!msalService.instance.getAllAccounts().length) {
        msalService.getLogger().verbose('No accounts found, returning false');
        router.navigate(['/landing']);
        return of(false);
      }

      // Otherwise, allow activation.
      msalService
        .getLogger()
        .verbose('Account found, allowing route activation');
      return of(true);
    }),
    catchError((error) => {
      msalService.getLogger().error('Error in customMsalGuard', error);
      // Optionally, you can handle errors by returning a UrlTree for a dedicated login page.
      router.navigate(['/landing']);
      return of(false);
    }),
  );
};

export const routes: Routes = [
  { path: 'landing', component: LandingComponent },
  { path: 'not-found', component: NotFoundComponent },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [CustomMsalGuard, PermissionGuard],
  },
  {
    path: 'energy-usage-dashboard',
    component: EnergyUsageDashboardComponent,
    canActivate: [CustomMsalGuard, PermissionGuard],
  },
  {
    path: 'optimise',
    component: OptimiseComponent,
    canActivate: [CustomMsalGuard, PermissionGuard],
  },
  {
    path: 'monthly-sales-dashboard',
    component: CtmDashboardComponent,
    canActivate: [CustomMsalGuard, PermissionGuard],
  },
  {
    path: '',
    canActivate: [CustomMsalGuard, DefaultRouteGuard],
    children: [],
  },
  // {
  //     path: '',
  //     component: MainComponent,
  //     children: [{
  //         path: 'dashboard',
  //         component: DashboardComponent,
  //         canActivate: [MsalGuard]
  //     }, {
  //         path: '',
  //         redirectTo: 'dashboard',
  //         pathMatch: 'full',
  //     }],
  // }
];
